module.exports = __webpack_public_path__ + "static/img/product_6.3b4d637.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_6.jpg
// module id = c6RO
// module chunks = 1